import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { select, Store } from '@ngrx/store';
import { Observable } from 'rxjs/Observable';
import { LoadDistributionDetail, SelectDevice, SetMapExpansion, StartDistribution, StopDistribution, ShowEarlyLate, FilterStreetsOnDistribution, SetInSearchMode, ToggleDeviceChanged, ToggleShowIcons, ToggleShowAllDevices, ToggleShowDistribution } from '../../store/distribution.actions';
import { getDistributionDetail, getSelectedDevice, getActiveWeek, getDeviceConfigurations, getShowAllDevices, getShowIcons, getShowDistribution, getFilteredStreets } from '../../store/distribution.reducer';
import { DistributionState } from '../../store/distribution.state';
import { DistributionViewModel } from '../../view-models/distribution.view-model';
import { StopDistributionReasonDto } from '../../../domain/models/stop-distribution-reason-dto';
import { DistributionTiming } from '../../../domain/enums/distribution-timing';
import { WeekOfYear } from '../../../domain/models';
import { isUndefined } from 'util';
import { DeviceConfiguration } from '../../view-models/device-configuration';
import { StreetItemViewModel } from '../../view-models/street-item.view-model';

@Component({
    selector: 'app-detail-container',
    template: `<app-detail
            [detail]="detailView$ | async"
            [deviceId]="selectedDevice$ | async"
            [filteredStreets]="filteredStreets$ | async"
            [deviceConfigurations]="deviceConfigurations$ | async"
            [localShowAllDevices]="showAllDevices$ | async"
            [localShowDistribution]="showDistribution$ | async"
            [localShowIcons]="showIcons$ | async"
            (goToOverview)="goToOverview()"
            (setDeviceSelected)="onSelectDevice($event)"
            (startDistribution)="OnStartDistribution($event)"
            (stopDistribution)="OnStopDistribution($event)"
            (showEarlyLate)="OnShowEarlyLate($event)"
            (showAllDevices)="onToggleShowAllDevices($event)"
            (showIcons)="onToggleShowIcons($event)"
            (showDistribution)="onToggleShowDistribution($event)"
            (toggleDeviceChanged)="onToggleDeviceChanged($event)"
            (setInSearchMode)="onSetInSearchMode()"
            (filterStreets)="OnFilterStreets($event)">
    </app-detail>`,
})
export class DetailContainerComponent implements OnInit {

    detailView$: Observable<DistributionViewModel>;
    selectedDevice$: Observable<string>;
    filteredStreets$: Observable<StreetItemViewModel[]>;
    deviceConfigurations$: Observable<DeviceConfiguration[]>;
    distributionTimingFilterOptions$: any;
    showAllDevices$: Observable<boolean>;
    showDistribution$: Observable<boolean>;
    showIcons$: Observable<boolean>;
    activeWeek: WeekOfYear;

    constructor(
        private route: ActivatedRoute,
        private router: Router,
        private store: Store<DistributionState>,
    ) {
        this.detailView$ = store.pipe(select(getDistributionDetail));
        this.selectedDevice$ = store.pipe(select(getSelectedDevice));
        this.deviceConfigurations$ = store.pipe(select(getDeviceConfigurations));
        this.filteredStreets$ = store.pipe(select(getFilteredStreets));
        this.showAllDevices$ = store.pipe(select(getShowAllDevices));
        this.showDistribution$ = store.pipe(select(getShowDistribution));
        this.showIcons$ = store.pipe(select(getShowIcons));
        store.pipe(select(getActiveWeek)).subscribe((val: WeekOfYear) => this.activeWeek = val);
    }

    ngOnInit(): void {
        this.store.dispatch(new SetMapExpansion(false));
        this.route.params
            .subscribe((params: any) => {
                this.store.dispatch(new LoadDistributionDetail(params.distributionId));
            });
    }

    goToOverview(): void {
        isUndefined(this.activeWeek) ?
            this.router.navigate(['distributions']) :
            this.router.navigate(['distributions'], { queryParams: { week: this.activeWeek.weekNumber } });
    }

    onSelectDevice(deviceId: string): void {
        this.store.dispatch(new SelectDevice(deviceId));
    }

    OnStartDistribution(distributionId: string): void {
        this.store.dispatch(new StartDistribution(distributionId));
    }

    OnStopDistribution(stopDistributionReasonDto: StopDistributionReasonDto): void {
        this.store.dispatch(new StopDistribution(stopDistributionReasonDto));
    }

    OnShowEarlyLate(toggle: boolean): void {
        this.store.dispatch(new ShowEarlyLate(toggle));
    }

    OnFilterStreets(timing: DistributionTiming): void {
        this.store.dispatch(new FilterStreetsOnDistribution(timing));
    }
    onToggleShowAllDevices(toggle: boolean): void {
        this.store.dispatch(new ToggleShowAllDevices(toggle));
    }
    onToggleShowIcons(toggle: boolean): void {
        this.store.dispatch(new ToggleShowIcons(toggle));
    }
    onToggleShowDistribution(toggle: boolean): void {
        this.store.dispatch(new ToggleShowDistribution(toggle));
    }
    onToggleDeviceChanged(event: any): void {
        this.store.dispatch(new ToggleDeviceChanged(event));
    }
    onSetInSearchMode(): void {
        this.store.dispatch(new SetInSearchMode(true));
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/distribution/containers/detail-container/detail-container.component.ts